import React from 'react';
import styles from '../styles';
import { FaCarCrash, FaBatteryThreeQuarters, FaClock, FaCog } from 'react-icons/fa';
import useMediaQuery from '../hooks/useMediaQuery';
import { useLanguage } from '../contexts/LanguageContext';

const Features = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { t } = useLanguage();

    const featuresStyles = {
        container: {
            ...styles.section,
            backgroundColor: '#FFFFFF',
            padding: isMobile ? '3rem 1rem' : '4rem 2rem',
        },
        headline: {
            ...styles.h2,
            marginBottom: '4rem',
            textAlign: 'center', // Center headline
        },
        featuresGrid: {
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
            gap: isMobile ? '3rem' : '2rem',
            maxWidth: '1200px',
            width: '100%',
            margin: '0 auto', // Center grid
        },
        featureColumn: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '1rem',
            textAlign: 'center', // Center text within grid item
        },
        icon: {
            fontSize: '3rem', // Adjusted for better visual balance
            color: styles.brandColor,
            marginBottom: '1.5rem',
        },
        featureTitle: {
            fontSize: '1.25rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            color: '#333',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
        },
        featureDescription: {
            ...styles.bodyText,
            textAlign: 'center',
            fontSize: '0.9rem',
            lineHeight: '1.6',
        }
    };

    const features = [
        {
            icon: <FaCarCrash style={featuresStyles.icon} />,
            title: t('features.impactTitle'),
            description: t('features.impactDescription'),
        },
        {
            icon: <FaBatteryThreeQuarters style={featuresStyles.icon} />,
            title: t('features.batteryTitle'),
            description: t('features.batteryDescription'),
        },
        {
            icon: <FaClock style={featuresStyles.icon} />,
            title: t('features.falseAlarmTitle'),
            description: t('features.falseAlarmDescription'),
        },
        {
            icon: <FaCog style={featuresStyles.icon} />,
            title: t('features.customizableTitle'),
            description: t('features.customizableDescription'),
        },
    ];

    return (
        <section style={featuresStyles.container}>
            <h2 style={featuresStyles.headline}>{t('features.headline')}</h2>
            <div style={featuresStyles.featuresGrid}>
                {features.map((feature, index) => (
                    <div key={index} style={featuresStyles.featureColumn}>
                        {feature.icon}
                        <h3 style={featuresStyles.featureTitle}>{feature.title}</h3>
                        <p style={featuresStyles.featureDescription}>{feature.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Features;
